import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { GiftItemRow } from '@models/gift';

import useGiftOrder from './hooks/useGiftOrder';

interface Props {
    type: string;
    giftItem: GiftItemRow;
    qty: number;
    giftCardImageId?: string;
}

function Footer({ giftItem, qty, giftCardImageId }:Props) {
  const { handleOrder, enabled, state } = useGiftOrder(giftItem, qty, giftCardImageId);
  return (
        <Column
                spacing={14}
                fullWidth
                as='footer'>
            <Row fullWidth justify='space-between'>
                <Text size='xl' fontWeight='bold'>결제금액</Text>
                <Text size='xl' fontWeight='bold' color={colors.red}>
                    {(giftItem.salePrice * qty * state.giftRecipients.length).toLocaleString()}원
                </Text>
            </Row>
            <Button fullWidth type='button'
                    disabled={!enabled}
                    onClick={handleOrder}>
                선물하기
            </Button>
        </Column>
  );
}

export default Footer;
